module.exports = __webpack_public_path__ + "img/spa-cafe.9c4aea53.svg";